import GeneralLogo from "./components/CompanyLogo/GeneralLogo";
import DontHaveAAccount from "./components/DontHaveAAccount/DontHaveAAccount";
import BaseForm from "./components/BaseForm/BaseForm";
import ForgotPassword from "../container/views/forgotPassword/ForgotPasswordForm";
import NewPassword from "./components/ResetForm/NewPassword";
import BaseRegistrationForm from "./components/BaseRegistrationForm/BaseRegistrationForm";
import VerifyEmail from "./components/VerifyEmail/VerifyEmail";
import FileUploader from "./components/UploadFile/FileUploader";
import SpinnerContainer from "./components/Spinner/SpinnerContainer";
import NotFoundPage from "./components/NotFound/NotFoundPage";
import BecomeVerifiedUser from "./components/BecomeVerifiedUser/BecomeVerifiedUser";
import BaseBecomeVerifiedUser from "./components/BaseBecomeVerifiedUser/BaseBecomeVerifiedUser";
import Button from "./components/Button/Button";
import VerifiedHeading from "./components/VerifiedHeading/VerifiedHeading";
import MultiSelect from "./components/MultiSelect/MultiSelect";
import BaseTable from "./components/Table/BaseTable";
import DataTable from "./components/Table/DataTable";
import CertifiedPractitionerHeading from "./components/BecomeCertifiedPractitioner/CertifiedPractitionerHeading";
import BaseBecomeCertifiedPractitioner from "./components/BaseBecomeCertifiedPractitioner/BaseBecomeCertifiedPractitioner";
import SportType from "./components/SportType/SportType";
import SportTypeDocs from "./components/SportTypeDocs/SportTypeDocs";
import CancelButton from "./components/CancelButton/CancelButton";
import ApprovedCertificate from "./components/ApproveRejectCertificate/ApprovedCertificate";
import RejectedCertificate from "./components/ApproveRejectCertificate/RejectedCertificate";
import NavBar from "./components/NavBar/NavBar";
import BecomeInstructorModal from "./components/Modals/BecomeInstructorModal";
import BecomeInstructor from "./components/BecomeInstructor/BecomeInstructor";
import CustomModal from "./components/CustomModal/CustomModal";
import ReactDatePickerWrapper from "./components/ReactDatePickerWrapper/ReactDatePickerWrapper";
import ExportComponent from "./components/ExportComponent/ExportComponent";
import ChangePasswordModal from "./components/Modals/ChangePasswordModal";
import ChangePassword from "./components/ChangePassword/ChangePassword";
import RegistrationSuccessModal from "./components/Modals/RegistrationSuccessModal";
import FindOnMapModal from "./components/Modals/FindOnMapModal";
import InputFieldWrapper from "./components/InputFieldWrapper/InputFieldWrapper";
import DataTableWithoutPagination from "./components/Table/DataTableWithoutPagination";
import ModalApprovedRejected from "./components/ModalApprovedRejected/ModalApprovedRejected";
import DeleteModal from "./components/Modals/DeleteModal";
import ActivityDetail from "./components/ActivityDetail/ActivityDetail";
import BaseUpdateUserDocuments from "./components/BaseUpdateUserDocuments/BaseUpdateUserDocuments";
import SubscriptionFields from "./components/SubscriptionFields/SubscriptionFields";
import ConfirmationModal from "./components/Modals/ConfirmationModal";
import PublishModal from "./components/Modals/PublishModal";
import RegistrationPaymentModal from "./components/RegisterationPaymentModal/RegistrationPaymentModal";
import LoginForm from "../container/views/login/LoginForm";
import StopPropagation from "./components/StopPropagation/StopPropagation";
import BecomeMemberModal from "./components/BecomeMember/BecomeMemberModal";
import InvoiceDetail from "./components/InvoiceDetail/InvoiceDetail";
import BecomeFreelanceInstructorPayment from "./components/Modals/BecomeFreelanceInstructorPayment";
import SavedCardForm from "./components/SavedCardForm/SavedCardForm";
import PricingModal from "./components/Modals/PricingModal";
import FreelancerPricingModal from "./components/Modals/FreelancerPricingModal";
import ServerFormatToDate from "./components/FormatDate/ServerFormatToDate";
import TimezoneDisplayText from "./components/TimezoneDisplayText/TimezoneDisplayText";
import AdminCertificateView from "./components/ApproveRejectCertificate/AdminCertificateView";
import ViewCertificateAttachments from "./components/Modals/ViewCertificateAttachments";
import BoatClassPaymentModal from "./components/Modals/BoatClassPaymentModal";
import ReviewStars from "./components/ReviewStars/ReviewStars";
import SaveCardModal from "./components/Modals/SaveCardModal";
import SaveCard from "./components/SaveCard/SaveCard";
import ShowUserLevels from "./components/ShowUserLevels/ShowUserLevels";
import ViewInvoiceLinks from "./components/Modals/ViewInvoiceLinks";

export const allSharedComponents = {
  GeneralLogo,
  DontHaveAAccount,
  BaseForm,
  ForgotPassword,
  NewPassword,
  BaseRegistrationForm,
  VerifyEmail,
  FileUploader,
  SpinnerContainer,
  NotFoundPage,
  BecomeVerifiedUser,
  BaseBecomeVerifiedUser,
  Button,
  VerifiedHeading,
  BaseTable,
  DataTable,
  CertifiedPractitionerHeading,
  BaseBecomeCertifiedPractitioner,
  SportType,
  SportTypeDocs,
  CancelButton,
  RejectedCertificate,
  ApprovedCertificate,
  MultiSelect,
  ConfirmationModal,
  NavBar,
  BecomeInstructorModal,
  BecomeInstructor,
  CustomModal,
  ReactDatePickerWrapper,
  ExportComponent,
  ChangePasswordModal,
  ChangePassword,
  RegistrationSuccessModal,
  FindOnMapModal,
  InputFieldWrapper,
  DataTableWithoutPagination,
  ModalApprovedRejected,
  DeleteModal,
  ActivityDetail,
  BaseUpdateUserDocuments,
  SubscriptionFields,
  PublishModal,
  RegistrationPaymentModal,
  LoginForm,
  StopPropagation,
  BecomeMemberModal,
  InvoiceDetail,
  BecomeFreelanceInstructorPayment,
  SavedCardForm,
  PricingModal,
  FreelancerPricingModal,
  ServerFormatToDate,
  TimezoneDisplayText,
  AdminCertificateView,
  ViewCertificateAttachments,
  BoatClassPaymentModal,
  ReviewStars,
  SaveCardModal,
  SaveCard,
  ShowUserLevels,
  ViewInvoiceLinks,
};
